// app/javascript/controllers/pflegeplatz_controllers/typewriter_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output", "cursor"]
  static values = { 
    phrases: { type: Array, default: ["Pflegegrad berechnen?", "Pflegegeld prüfen?", "Antragshilfe?"] },
    typeSpeed: { type: Number, default: 40 }, // lower number means higher speed
    deleteSpeed: { type: Number, default: 30 }, // lower number means higher speed
    pauseDuration: { type: Number, default: 1500 }
  }

  connect() {
    this.phraseIndex = 0
    this.charIndex = 0
    this.isDeleting = false
    this.animate()
  }

  disconnect() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
      this.animationTimeout = null;
    }
  }

  animate() {
    const currentPhrase = this.phrasesValue[this.phraseIndex % this.phrasesValue.length]
    
    // Determine the visible text
    this.outputTarget.textContent = currentPhrase.substring(0, this.charIndex)

    let nextSpeed = this.typeSpeedValue

    if (this.isDeleting) {
      nextSpeed = this.deleteSpeedValue
    }

    if (!this.isDeleting && this.charIndex < currentPhrase.length) {
      // Typing
      this.charIndex++
    } else if (this.isDeleting && this.charIndex > 0) {
      // Deleting
      this.charIndex--
    } else if (!this.isDeleting && this.charIndex === currentPhrase.length) {
      // Finished typing phrase, pause before deleting
      this.isDeleting = true
      nextSpeed = this.pauseDurationValue
    } else if (this.isDeleting && this.charIndex === 0) {
      // Finished deleting, move to next phrase
      this.isDeleting = false
      this.phraseIndex++
      nextSpeed = 400
    }

    this.animationTimeout = setTimeout(() => this.animate(), nextSpeed)
  }
}